export const EVENT_SOCKET = {
  CLOSE_EVENT: 'CLOSE-EVENT',
  OPEN_EVENT: 'OPEN-EVENT',
  SEEN_EVENT: 'SEEN',
  TEXT_EVENT: 'TEXT',
  ADD_NOTIFICATION: 'ADD',
  REMOVE_NOTIFICATION: 'REMOVE',
}
